module.exports = __webpack_public_path__ + "img/31-indicadores-docs-hub.6daa08f1.png";